import React from 'react';
import {
  FormFieldRequiredSource,
  isFormFieldRequired,
} from 'components/anvilFormFillable/utils';

type Props = FormFieldRequiredSource & {
  name?: string | null;
};

export default function FormFieldInlineLabel({
  name,
  isRequired,
  type,
}: Props) {
  const required = isFormFieldRequired({ isRequired, type });

  return (
    <span className="font-semibold">
      {name}
      {!required && (
        <span className="text-[11px] italic font-normal text-gray-400 ml-1">(Optional)</span>
      )}
    </span>
  );
}
